import { makeStyles, Typography } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme: any) => ({
  footerTextContainer: {
    marginTop: theme.spacing(3),
  },
  footerText: {
    fontSize: theme.fontSizes.onboarding,
  },
  bold: {
    fontWeight: 700,
  },
}));

export default function AccountFooterText() {
  const classes = useStyles();

  return (
    <div className={classes.footerTextContainer}>
      <Typography paragraph align="center" className={classes.footerText}>
        <u className={classes.bold}>Our promise</u>: We will never abuse, modify
        or reveal your data, nor use it for any purpose other than that stated
        above.
      </Typography>
    </div>
  );
}
